import React from "react";
import BaseBreadcrumb from "./base-breadcrumb";
import NTBreadcrumb from "./nt-breadcrumb/NTBreadcrumb";

const Breadcrumb = ({
  domain,
  datatype,
  group,
  input,
}: {
  domain: string | null;
  datatype: string | null;
  group: string | null;
  input?: string | null;
}) => {
  return ["nrdata-orig", "FAF-nt"].includes(
    process.env.REACT_APP_STYLING_THEME ?? "",
  ) ? (
    <NTBreadcrumb
      domain={domain}
      datatype={datatype}
      group={group}
      input={input}
    />
  ) : (
    <BaseBreadcrumb
      domain={domain}
      datatype={datatype}
      group={group}
      input={input}
    />
  );
};

export default Breadcrumb;
